'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useEffect, useRef, useState} from 'react';
// @ts-ignore
import {AdyenCheckout, Card} from '@adyen/adyen-web';
import cn from 'classnames';
import etask from 'zetask';
import zurl from 'zurl';
import zutil from '/util/util.js';
import csrf from '/util/csrf.js';
import plus_util from '/www/hola/pub/plus_util.js';
import '/www/hola/pub/modal.js';
// @ts-ignore
import {Input} from '/www/hola/pub/lib/input.js';
import {Button} from '../../../../shared/button';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import string from '/util/string.js';
import {t_premium_page_opt} from '../premium/use_premium_page';
import {use_qs} from '../../lib/use_qs';
import styles from './cc_adyen.module.less';
// @ts-ignore
import {get_price_plan} from '../../../../../svc/account/pub/membership';
import {i_plan} from '../../plus/plus_types';
import zerr from '/util/zerr.js';

const {qw} = string;

const tnx_succeed = tnx=>tnx&&tnx.resultCode==='Authorised';
const tnx_3ds = tnx=>
    tnx && ['RedirectShopper', 'IdentifyShopper'].includes(tnx.resultCode);

type t_payment_form_props = {
    get_email: (email: string, user: any)=>string;
    set_email: (email: string)=>void;
    before_payment?: ()=>void;
    after_payment?: ()=>void;
    on_submit_err?: (resp: any)=>void;
    set_fallback_route?: ()=>void;
    on_payment?: (resp: any)=>void;
    submit_payment?: (type: string, opt: any)=>void;
    submitting: boolean;
    set_submitting?: (s: boolean)=>void;
    Button_cmp?: any;
    before_btn_component?: any;
    submit_caption?: string|JSX.Element;
    btn_props?: any;
};

type t_cc_adyen_props = t_payment_form_props & t_premium_page_opt & {
    session_flow?: boolean;
    on_load?: ()=>void;
    show: boolean;
    Skeleton_comp?: React.FC<{abs?: boolean}>
    with_skeleton?: boolean;
};

export const CC_adyen = (props: t_cc_adyen_props)=>{
    const {show, with_skeleton, Skeleton_comp} = props;
    const {user, plan, currency, country} = props;
    const {price} = get_price_plan(plan, currency);
    useEffect(()=>props.on_load && props.on_load(), []);

    const [hide_controls, set_hide_controls] = useState(false);
    const _email = props.get_email && props.get_email(props.email, user)
         || plus_util.get_email(props.email, user);
    const [email, set_email] = useState(_email);
    const on_email_change = v=>{
        props.set_email && props.set_email(v);
        set_email(v);
    };
    const [email_error, set_email_error] = useState(props.email_error);
    const set_email_err = e=>{
        props.set_email_err && props.set_email_err(e);
        set_email_error(e);
    };

    const [error, set_error] = useState('');
    const [card, set_card] = useState<Card>(null);
    const [card_valid, set_card_valid] = useState(false);
    const on_submitted = has_actions=>{
        props.set_submitting && props.set_submitting(false);
        set_hide_controls(has_actions);
    };

    // We change key on component to force
    // complete remounting of component when
    // component's props changes to clean DOM for UI-lib
    const key = undefined; // `${country}_${currency}_${price}`;
    const params = {key, email, plan, price, currency, country,
        form: props, set_card, set_error, set_card_valid, on_submitted};

    const form_ready = ()=>
        !props.submitting && email && !email_error && card_valid;
    const on_submit = ()=>form_ready() && card?.submit();
    const Button_cls = props.Button_cmp||Button;
    return <div className={cn(styles.adyen, !show && styles.hidden)}>
      <CC_adyen_card {...params} />
      {!hide_controls && !user && <Input
        cl={cn('email_field', 'field_email')}
        name="email" auto_complete="email" value={email}
        validator={plus_util.email_validator} inputmode="email"
        placeholder={'name@example.com'} label="Email address"
        on_validation={set_email_err} error={email_error}
        on_change={on_email_change}/>}
      {!hide_controls && props.before_btn_component}
      {!hide_controls && <Button_cls arrow caption={props.submit_caption}
        {...(props.btn_props||{})} disabled={!form_ready()}
        on_click={on_submit} />}
      {!!error && <div className="alert-danger alert">{error}</div>}
      {!card && with_skeleton && <Skeleton_comp abs/>}
    </div>;
};

const after_payment = (dropin, resp, form)=>etask(function*(){
    // Payment not done yet
    if (tnx_3ds(resp))
        return;
    const succeed = tnx_succeed(resp), status = succeed ? 'success' : 'error';
    dropin.setStatus(status);
    plus_util.perr({id: 'www_premium_payment_submit_adyen',
        info: {hola_uid: resp.hola_uid, hola_plan_id: resp.hola_plan_id}});
    if (form?.after_payment)
        yield form.after_payment(resp);
    if (succeed && resp.back_url)
    {
        location.href = (resp.back_url.includes('//') ? '' : '//')
            + resp.back_url;
    }
});

const on_err = err=>console.error(err);

const submit_payment = (type, opt, form: t_cc_adyen_props)=>{
    const {dropin} = opt, {user} = form;
    opt = zutil.omit(opt, 'dropin');
    plus_util.perr({id: 'www_premium_payment_submit_clicked_adyen',
        info: {hola_uid: user?.hola_uid, period: opt.plan.period,
            hola_plan_id: opt.plan.id}});
    const _opt = {
        on_err,
        email: opt.email,
        after_payment: resp=>after_payment(dropin, resp, form),
    };
    for (const k in opt)
        zutil.if_set(opt[k], _opt, k);
    if (form?.submit_payment)
        return form.submit_payment(type, _opt);
    return plus_util.payment_api(type, _opt);
};

type t_info = {
    country_code: string;
    currency: string;
    env: 'test' | 'live';
    plan: i_plan;
    price: number;
    email: string;
}

const adv_make_payment = (info: t_info, form: t_cc_adyen_props,
    state, dropin, actions, set_error, on_submitted)=>etask(function*(){
    this.on('uncaught', e=>{
        console.error(e);
        actions.reject();
    });
    let resp = null;
    const on_payment_error = (error_msg: string, e?: unknown)=>{
        set_error(error_msg, dropin);
        if (form.set_submitting)
            form.set_submitting(false);
        if (form.on_submit_err)
            return form?.on_submit_err(resp);
        plus_util.perr({id: 'www_premium_payment_submit_failed_adyen',
            error_msg,
            exception: zerr.e2s(e),
            info: {
                hola_uid: resp?.hola_uid,
                hola_plan_id: resp?.hola_plan_id}});
    };
    try {
        set_error('');
        resp = yield submit_payment('adyen', {...info, state, dropin}, form);
        if (!resp?.resultCode)
        {
            on_payment_error('Network error');
            return actions.reject();
        }
        const {action} = resp;
        form?.set_submitting && form.set_submitting(false);
        if (resp.refusalReason)
            set_error(resp.refusalReason, dropin);
        if (!action)
            form?.on_payment && form.on_payment(resp);
        on_submitted && on_submitted(!!action);
        actions.resolve(resp);
    } catch(e){
        on_payment_error('Network error', e);
        actions.reject();
        throw e;
    }
});

const adv_make_details = (info: t_info, form: t_cc_adyen_props,
    state, dropin, actions, set_error)=>etask(function*(){
    this.on('uncaught', e=>{
        console.error(e);
        actions.reject();
    });
    form?.set_submitting && form.set_submitting(true);
    // const {data} = state;
    const email = info.email;
    const resp = yield fetch('/users/payment/adyen_details', {
        method: 'POST', json: true, body: {info, state, email}});
    if (resp.refusalReason)
        set_error(resp.refusalReason, dropin);
    if (!tnx_succeed(resp))
    {
        actions.reject();
        if (form.on_submit_err)
            form?.on_submit_err(resp);
    }
    else
    {
        form?.on_payment && form.on_payment(resp);
        actions.resolve(zutil.pick(resp, ...qw`resultCode action
            order donationToken`));
    }
    return yield after_payment(dropin, resp, form);
});

const adyen_error = (form: t_cc_adyen_props, err)=>{
    console.error(err);
    // @ts-ignore
    const errors = window.global_adyen_errors = window.global_adyen_errors||[];
    // Ignore same error
    if (err instanceof Error && errors.includes(err))
        return;
    errors.push(err);
    if (errors.length>2 && form?.set_fallback_route)
        form.set_fallback_route();
};

type t_cc_adyen_card_props = {
    country?: string,
    email: string,
    plan: string,
    price: string,
    currency: string
    form: t_cc_adyen_props,
    set_error: (e: string)=>void,
    set_card: (c: Card)=>void,
    set_card_valid: (s: boolean)=>void,
    on_submitted: (s: boolean)=>void,
}

const CC_adyen_card = (_props: t_cc_adyen_card_props)=>{
    const cur_qs = use_qs();
    const force_test_env = Boolean(cur_qs.test);
    const ref_dropin = useRef<HTMLDivElement>();
    const ref_props = useRef(_props);
    ref_props.current = _props;
    const set_error = (err_line, dropin)=>{
        const props = ref_props.current;
        if (err_line)
            adyen_error(props.form, err_line);
        if (dropin && err_line)
            dropin.setStatus('error');
        props.set_error(err_line);
    };
    const submit_error = e=>{
        const props = ref_props.current;
        adyen_error(props.form, e);
        if (props.form.on_submit_err)
            props.form.on_submit_err(e);
    };
    useEffect(()=>{ etask(function*(){
        this.on('uncaught', submit_error);
        const args: {csrf_token: string, test_env?: number} =
            {csrf_token: csrf.get()};
        if (force_test_env)
            args.test_env = 1;
        const creds = yield fetch(`/users/payment/adyen_creds?${
            zurl.qs_str(args)}`, {json: true});
        const info_fn = ()=>({
            country_code: ref_props.current?.country||creds.country,
            ...zutil.pick(ref_props.current, qw`plan price currency email`),
            ...zutil.pick(creds, qw`env token`)
        });
        const methods = yield fetch('/users/payment/adyen_payment_methods',
            {method: 'POST', json: true, body: {info: info_fn()}});
        if (methods.error)
            throw new Error(`err_get_payments: ${methods.error}`);
        if (!methods.paymentMethods)
            throw new Error(`err_get_payments: no payment methods`);
        const checkout = yield AdyenCheckout({
            environment: creds.env,
            paymentMethodsResponse: methods,
            clientKey: creds.client_key,
            countryCode: ref_props.current?.country||creds.country,
            locale: 'en-US',
            analytics: {enabled: false},
        });
        const cardConfig = {
            hasHolderName: true,
            holderNameRequired: true,
            billingAddressRequired: false,
            enableStoreDetails: false,
            showPayButton: false,
            challengeWindowSize: '05' as const,
            onError: submit_error,
            onChange: state=>ref_props.current.set_card_valid(state.isValid),
            onSubmit: (state, dropin, actions)=>{
                const props = ref_props.current;
                zutil.if_set(cur_qs['3ds'], state, '3ds');
                return adv_make_payment(info_fn(), props.form,
                    state, dropin, actions, set_error, props.on_submitted);
            },
            onAdditionalDetails: (state, dropin, actions)=>adv_make_details(
                info_fn(), ref_props.current.form, state, dropin, actions,
                set_error),
        };
        ref_props.current.set_card(new Card(checkout, cardConfig)
            .mount(ref_dropin.current));
    }); }, []);
    return <div key="div_dropin" ref={ref_dropin} />;
};
